<template>
    <div>
        <div class="block-content tab-content">
            <div class="form-group row">
                <div class="controls col-lg-12">
                    <span class="row mb-2">
                        <span class="col-sm-12">
                            <div class="row mb-3 justify-content-between">
                                <!-- // filter by venue -->
                                <div class="col-sm-4" v-if="filterType == 'product'">
                                    <div class="input-group addon-select">
                                        <select
                                            id="productVenueFilter"
                                            class="form-control"
                                            v-model="filter1"
                                            @change="$emit('filter-by-venue', filter1)"
                                        >
                                            <option value="" selected>
                                                --filter by venue--
                                            </option>
                                            <option
                                                v-for="venue in venues"
                                                :value="venue.id"
                                                :key="`venue-filter-${venue.id}`"
                                            >
                                                {{ venue.name }}
                                            </option>
                                        </select>
                                        <div class="input-group-append">
                                            <a
                                                :href="`/admin/${partnerId}/venue/${filter1}`"
                                                v-if="filter1"
                                                class="btn btn-info"
                                            >
                                                <i class="fa fa-external-link-alt"></i></a>
                                            <button
                                                disabled="disabled"
                                                v-else
                                                class="btn btn-info"
                                            ><i class="fa fa-external-link-alt"></i></button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-4" v-if="filterType == 'product'">
                                    <select
                                        id="productCategoryFilter"
                                        class="form-control"
                                        v-model="filter2"
                                        @change="$emit('filter-by-category', filter2)"
                                    >
                                        <option value="" selected>--filter by category--</option>
                                        <optgroup label="Product Categories">
                                            <option
                                                v-for="category in categories"
                                                :value="category.id"
                                                :key="'category-filter-'+category.id"
                                            > {{ category.name }}</option>
                                        </optgroup>
                                    </select>
                                </div>

                                <div class="col-sm-3" v-if="filterType == 'product'">
                                    <div class="input-group addon-select">
                                        <select
                                            id="productCampaignFilter"
                                            class="form-control"
                                            v-model="filter3"
                                            @change="$emit('filter-by-campaign', filter3)"
                                        >
                                            <option value="">--filter by campaign--</option>
                                            <option
                                                v-for="campaign in campaigns"
                                                :value="campaign.id"
                                                :key="'campaign-filter-'+campaign.id"
                                            >{{ campaign.name }}</option>
                                        </select>
                                        <div class="input-group-append">
                                            <a
                                                :href="`/admin/${partnerId}/campaign/${filter3}`"
                                                v-if="filter3"
                                                class="btn btn-info"
                                            ><i class="fa fa-external-link-alt"></i></a>
                                            <button
                                                disabled="disabled"
                                                v-else
                                                class="btn btn-info"
                                            ><i class="fa fa-external-link-alt"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-success"
                                        :disabled="disabledAdd"
                                        @click="addItemToFilter(selected)"
                                    >Add</button>
                                </div>
                            </div>

                        </span>
                        <!-- // PRODUCT FILTER -->
                        <select
                            id="addProduct"
                            name="addProduct"
                            class="form-control"
                            style="height:175px;"
                            multiple
                            v-model="selected"
                            v-if="filterType == 'product' || filterType == 'productSimple'"
                        >
                            <optgroup
                                v-for="(value, key) in filterOptGroup"
                                :label="key"
                                :key="key"
                            >
                                <option
                                    v-for="product in value"
                                    :value="product.id"
									:key="`addProduct-${product.id}`"
                                >
                                    {{ product.name }}
                                </option>
                            </optgroup>
                        </select>
                        <!-- // DEAL FILTER -->
                        <select
                            id="addDeal"
                            name="addDeal"
                            class="form-control"
                            style="height:175px;"
                            multiple
                            v-model="selected"
                            v-if="filterType == 'deal'"
                        >
                            <option
                                v-for="deal in deals"
                                :value="deal.id"
                                :key="`addDeal-${deal.id}`"
                            >
                                {{ deal.name }}
                            </option>
                        </select>
                        <!-- // PERK FILTER -->
                        <select
                            id="addPerk"
                            name="addPerk"
                            class="form-control"
                            style="height:175px;"
                            multiple
                            v-model="selected"
                            v-if="filterType == 'perk'"
                        >
                            <option
                                v-for="perk in perks"
                                :value="perk.id"
                                :key="`addPerk-${perk.id}`"
                            >
                                {{ perk.name }}
                            </option>
                        </select>
                        <!-- // PACKAGE FILTER -->
                        <select
                            id="addPackage"
                            name="addPackage"
                            class="form-control"
                            style="height:175px;"
                            multiple
                            v-model="selected"
                            v-if="filterType == 'package'"
                        >
                            <option
                                v-for="packag in packages"
                                :value="packag.id"
                                :key="`addPackage-${packag.id}`"
                            >
                                {{ packag.name }}
                            </option>
                        </select>

                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        partnerId: {
            type: Number
        },
        filterType: {
            type: String,
            default: 'product'
        },
        deals: {
            type: Array,
            default() { return [] }
        },
        venues: {
            type: Array,
            default() { return [] }
        },
        packages: {
            type: Array,
            default() { return [] }
        },
        perks: {
            type: Array,
            default() { return [] }
        },
        categories: {
            type: Array,
            default() { return [] }
        },
        campaigns: {
            type: Array,
            default() { return [] }
        },
        products: {
            type: Array,
            default() { return [] }
        },
    },
    data() {
        return {
            filter1: '',
            filter2: '',
            filter3: '',
            selected: [],
        }
    },
    methods: {
        addItemToFilter(selected) {
            this.$emit('added-items', selected)
        }
    },
    computed: {
      disabledAdd() {
           return !((this.filterType == 'package' && this.packages.length > 0) ||
                  (this.filterType == 'perk' && this.perks.length > 0) ||
                  (this.filterType == 'deal' && this.deals.length > 0) ||
                  ((this.filterType == 'product' || this.filterType == 'productSimple') && this.products.length > 0));
        },
        filterOptGroup() {
					this.products.map((product) => {
						if (product.venueName == null) {
							product.venueName = 'No Venue'
						}
					});
            return window.groupBy(this.products, 'venueName')
        }
    },
}
</script>

<style>
</style>